/// <reference path="../../app.definition.ts" />

import angular from "angular";
import { OverlayMessage } from "@common/service/overlay.service";
import * as HTMLUtil from "@common/utility/html";
export enum TooltipDirectionEnum {
    TOP = 'TOP',
    LEFT = 'LEFT',
    BOTTOM = 'BOTTOM',
    RIGHT = 'RIGHT'
}

export interface IwalkThroughService {

}

export class WalkThroughItem {
    order: number;
    text: string;
    offset: number;
    containerDoMId: string;
    targetDoMId: string;
    width: number;
    height: number;
    cssClass: string;
    tooltipDirection: Array<TooltipDirectionEnum>;

    constructor(order, text, containerId, targetId, cssClass = 'how-message', width = 300, height = 50, tooltipDir = [TooltipDirectionEnum.TOP], offset = 15) {
        this.order = order;
        this.text = text;
        this.containerDoMId = '#' + containerId;
        this.targetDoMId = '#' + targetId;
        this.width = width;
        this.height = height;
        this.tooltipDirection = tooltipDir;
        this.offset = offset;
        this.cssClass = cssClass;
    }
}

export class WalkThroughService implements IwalkThroughService {
    tour: Array<WalkThroughItem> = [];
    compile;
    scope;
    currentIndex;
    tooltipDoMs = {};
    callBacks = {
        onEndTour: null,
        onNext: null, // we can utilize this in future
        onPrev: null // we can utilize this in future
    }

    static $inject = ["$timeout"];
    constructor(private $timeout) {

    }

    removeTooltip = (index?) => {
        if (typeof index == 'number' && index > 0 && index < this.tour.length) {
            if (this.tooltipDoMs[index]) {
                this.tooltipDoMs[index].$el.remove();
                delete this.tooltipDoMs[index];
            }
        } else {
            for (var key in this.tooltipDoMs) {
                if (this.tooltipDoMs[key]) {
                    this.tooltipDoMs[key].$el.remove();
                    delete this.tooltipDoMs[key];
                }
            }
        }
    }

    init = (arr, compile, scope, callBacks) => {
        arr = arr.sort((a, b) => a.order - b.order);
        this.currentIndex = 0;
        this.compile = compile;
        this.scope = scope;
        this.tour = arr;
        this.callBacks = callBacks || this.callBacks;
    };

    start = () => {
        this.currentIndex = -1;
        this.nextItem();
    }

    nextItem = (index?, clearPrevMsg = true) => {
        if ((!!index && index > this.currentIndex) || !index) {
            // if it is called for next item then and then show next tool tip
            if (typeof index == 'number' && index > -1 && index < this.tour.length) {
                this.currentIndex = index;
                this.showMessage(this.tour[index], index, clearPrevMsg);
            } else if (this.currentIndex < this.tour.length) {
                index = ++this.currentIndex;
                this.showMessage(this.tour[index], index, clearPrevMsg);
            }
        }
    };

    prevItem = () => {
        if (this.currentIndex < this.tour.length) {
            let index = ++this.currentIndex;
            this.showMessage(this.tour[index], index);
        }
    };

    end = () => {
        this.removeTooltip();
        if (!!this.callBacks.onEndTour) {
            this.callBacks.onEndTour();
        }
    };

    reset = () => {
        this.removeTooltip();
        this.compile = null;
        this.scope = null;
        this.tour = [];
        this.tooltipDoMs = {};
        this.callBacks = null;
    }

    getPosition = (container, target, tourItem) => {
        var rtnObject = null;
        var rtnObjs = {
            RIGHT: { placement: 'right', offset: new HTMLUtil.Offset(tourItem.offset, 0) },
            LEFT: { placement: 'left', offset: new HTMLUtil.Offset(tourItem.offset * -1, 0) },
            TOP: { placement: 'top', offset: new HTMLUtil.Offset(0, tourItem.offset * -1) },
            BOTTOM: { placement: 'bottom', offset: new HTMLUtil.Offset(0, tourItem.offset) }
        };
        var possibilities = {
            RIGHT: false,
            LEFT: false,
            TOP: false,
            BOTTOM: false
        };
        var obj = {
            x: target.offset().left - container.offset().left,
            y: target.offset().top - container.offset().top,
            w: target.width(),
            h: target.height()
        }
        // get placement possibilities for tooltip for each side
        possibilities.RIGHT = ((container.width() - obj.x - obj.w - tourItem.offset - tourItem.width) >= 0);
        possibilities.LEFT = ((obj.x - tourItem.offset - tourItem.width) >= 0);
        possibilities.TOP = ((container.height() - obj.h - tourItem.offset - tourItem.height) >= 0);
        possibilities.BOTTOM = ((container.height() - (obj.y + obj.h + tourItem.offset + tourItem.height)) >= 0);

        for (var i = 0; i < tourItem.tooltipDirection.length; i++) {
            if (possibilities[tourItem.tooltipDirection[i]]) {
                rtnObject = rtnObjs[tourItem.tooltipDirection[i]];
                break;
            }
        }
        return rtnObject;
    }

    showMessage = (tourItem, index, clearPrevMsg = true) => {
        var configObj;
        if (clearPrevMsg) {
            this.removeTooltip();
        }
        this.$timeout(() => {
            var obj;
            var container = $(tourItem.containerDoMId);
            if (container.length == 1) {
                var target = container.find(tourItem.targetDoMId);
                obj = this.getPosition(container, target, tourItem);
                configObj = {
                    relativeTo: target,
                    selector: tourItem.targetDoMId,
                    placement: obj.placement,
                    offset: obj.offset,
                    content: tourItem.text,
                    classAttr: tourItem.cssClass
                };
                this.$timeout(() => {
                    if (target.length == 1) {
                        var m = new OverlayMessage(configObj);
                        m.createElement();
                        HTMLUtil.placeElement(m.$el, m.relativeTo, m.offset, m.placement, tourItem.containerDoMId, this.compile, this.scope, tourItem.width, tourItem.height);
                        m.addArrow(target);
                        this.tooltipDoMs[index] = m;
                    }
                }, 100);
            }
        }, 100);
    }
}

angular.module("eCareVault.common.services")
    .service("WalkThroughService", WalkThroughService);
